enum BooleanLogicOperationTypes {
  None = 0,
  And = 1,
  Or = 2,
};

export default BooleanLogicOperationTypes;